export const BackButton = (props) => {
    return (
        <svg width="15" height="24" viewBox="0 0 15 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.89683 11.6949L14.4229 3.16891L11.9873 0.733398L1.0258 11.6949L11.9873 22.6565L14.4229 20.221L5.89683 11.6949Z" fill={props.fill ? props.fill : '#848484'} />
        </svg>
    );
};
